module.exports = __webpack_public_path__ + "static/media/eva-mockup.3ce64fb0.png";